import React from 'react';
import PropTypes from 'prop-types';
import Grid from 'material-ui/Grid';
import Hidden from 'material-ui/Hidden';
import applyImg from '../assets/imgApply.png';
import guidelinesImg from '../assets/imgGuidelines.png';
import checklistPDF from '../assets/SachsApplicationChecklist.pdf';
import applicationPDF from '../assets/SachsSubmissionForm.pdf';

class Applications extends React.Component {

  render() {
    return (
      <Grid id='applications' container justify='center' alignItems='center' spacing={0} align='left'>
        <Hidden smDown>
          <Grid item sm={4} className='sectionImg'>
            <img src={guidelinesImg} alt='Woman Working' width='100%' />
          </Grid>
        </Hidden>
        <Grid item xs={12} md={8} className='sectionText sectionText--top'>
          <h1>Funding Guidelines</h1>
          <p>
            The Foundation's most important guiding principle is that it seeks to engage in philanthropic activities and to fund charitable organizations and institutions that have demonstrated they are self-sustaining, or clearly have the potential to become self-sustaining, or that focus on self-sustaining operations and activities.
          </p>
          <p>
            Accordingly, the Foundation's primary focus is dedicated to strengthening the economic base of low income, disadvantaged communities, primarily within the U.S., but also in developing countries. The Foundation has a keen interest in supporting charitable organizations and institutions that have developed clear and effective economic development programs. To this end, the Foundation provides financial support, usually in the form of low interest rate loans known as Program Related Investments ("PRI's"), to a variety of 501c3 tax exempt charitable organizations and institutions.
          </p>
            <span>
              <p>
                In addition to its PRI program funding, the Foundation also makes charitable grants in the areas of education, health and housing. The Foundation has made grants (in the form of merit-based college scholarships) to low-income San Francisco Bay Area students, as well as to performance arts programs providing economical access to lower income individuals and families. The Foundation will also consider grants outside of its established guidelines, provided it can be demonstrated that the grant will be of significant assistance at a critical time in the development of an idea or project that has the clear potential to become self-sustaining/self-supporting.
              </p>
            </span>
        </Grid>
        <Grid item xs={12} md={8} className='sectionText teal'>
          <h1 className='teal'>Application Procedures</h1>
          <p>
            The Foundation reviews PRI and grant proposals from 501c3 tax-exempt charitable organizations and institutions that meet the Foundation's established guidelines and provide the information set forth below. Applicants are encouraged to call the Foundation to informally discuss their programs and financial needs prior to submitting a written application. There are no application deadlines and proposals may be submitted at any time. Receipt of all applications will be acknowledged in writing. Applications are promptly reviewed as received, typically within 30 days of submission.
          </p>
          <p>
            Once the applicant has determined that its funding request falls within the Foundation’s established guidelines, it may submit a proposal/application for either a PRI or grant. Applications must include all of the components listed on the Application Check List. Applications will not be reviewed unless they are complete when submitted, and must be accompanied by a completed Proposal Submission Form.
          </p>
          <h2 className='green'>Application Forms</h2>
          <p>
            <ul>
              <li><a href={checklistPDF} target='blank'>Application Check List</a></li>
              <li><a href={applicationPDF} target='blank'>Proposal Submission Form</a></li>
            </ul>
          </p>
        </Grid>
        <Hidden smDown>
          <Grid item sm={4} className='sectionImg'>
            <img src={applyImg} alt='Peace Sign' width='100%' />
          </Grid>
        </Hidden>
      </Grid>
    );
  }
}

Applications.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default Applications;





// WEBPACK FOOTER //
// ./src/views/Applications.js